import { Component, OnInit } from '@angular/core';
import { MenuItem } from '@layouts/menu/menu.model';
import { AuthService } from '@core/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-b2b-sidebar',
  template: '<app-menu (menuClickEvent)="onClickEvent($event)" [selectedMenu]="selectedMenu"></app-menu>',
  styleUrls: ['./b2b-sidebar.component.scss']
})
export class B2bSidebarComponent implements OnInit {

  selectedMenu: MenuItem;

  constructor(private authService: AuthService,
              private router: Router) {
  }

  ngOnInit(): void {
  }

  onClickEvent(ev) {
    this.selectedMenu = ev;
  }
}
